import { BuilderContext } from '@ha/algolia';
import { GlobalState } from 'ha/types/store';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';
import { getSelectedVariants } from 'ha/modules/Experiments/selectors';
import EXPERIMENTS from 'ha/constants/experiments';

export const getFilterBuilderContext = (
  state: GlobalState,
  queryType:
    | 'listings'
    | 'priceFacet'
    | 'propertyTypeFacet'
    | 'propertySizeFacet',
): BuilderContext => {
  // add experiments and feature flags regarding algolia query here
  const { withDynamicMinimumPrice, searchNewDateLogicExp } =
    getFeatureFlags(state);
  const expVariant = getSelectedVariants(state)[EXPERIMENTS.HA8438.name];

  const isNewDateLogicEnabled =
    searchNewDateLogicExp === 'on' && expVariant === 'B';

  return {
    withoutPrice: queryType === 'priceFacet',
    withoutPropertyType: queryType === 'propertyTypeFacet',
    withDynamicMinimumPrice: withDynamicMinimumPrice === 'on',
    withoutPropertySize: queryType === 'propertySizeFacet',
    withNewDateFilter: isNewDateLogicEnabled,
  };
};
